<template>
    <div ref="node" class="spreadsheet-warpper" style="width:100%; height:600px;"></div>
</template>
<style lang="less">
    .spreadsheet-warpper{
        .x-spreadsheet-bottombar{
            display: none;
        }
    }
</style>
<script>
import Spreadsheet from "x-data-spreadsheet";
import zhCN from 'x-data-spreadsheet/src/locale/zh-cn';
Spreadsheet.locale('zh-cn', zhCN);
export default {
    props:['value'],
    mounted(){
        this.sheetInst = new Spreadsheet(this.$refs.node,{
            showToolbar: false,
            view: {
                height: () => this.$refs.node.clientHeight,
                width: () => this.$refs.node.clientWidth,
            },
        });
        if(this.value){
            this.sheetInst.loadData(this.tableToSheet(this.value));
        }
        this.sheetInst.change(data => {
            let table = this.sheetToTable(data);
            this.$emit('input', table);
        });
        this.sheetInst.validate();
    },
    watch: {
        value(){
            if(this.value){
                // this.sheetInst.loadData(this.tableToSheet(this.value));
            }
        }
    },
    methods: {
        tableToSheet(table){
            let rows = {};
            rows.len = table.length||100;
            for (let i = 0; i < table.length; i++) {
                const row = table[i];
                if(row){
                    let cells = {};
                    for (let j = 0; j < row.length; j++) {
                        const cell = table[i][j];
                        if(cell){
                            cells[j] = {
                                text:cell
                            }   
                        }
                    }
                    rows[i] = {cells};
                }
            }
            let sheet = {
                "name":"sheet1",
                "freeze":"A1",
                "styles":[{"font":{"italic":true}},
                {"border":{"bottom":["thin","#000"],"top":["thin","#000"],"left":["thin","#000"],"right":["thin","#000"]}}],
                "merges":[],
                "rows":rows,
                "cols":{"len":26},
                "validations":[],
                "autofilter":{}
            }
            return sheet;
        },

        sheetToTable(sheet){
            let table = [];
            try {
                let rows = sheet.rows;
                Object.keys(rows).forEach(rowIndex=>{
                    let index = Number(rowIndex);
                    if(!Number.isNaN(index)){
                        let row = rows[rowIndex];
                        let cells = row.cells;
                        let tcells = [];
                        Object.keys(cells).forEach(cellIndex=>{
                            let tcellIndex = Number(cellIndex);
                            if(!Number.isNaN(tcellIndex)){
                                tcells[tcellIndex] = cells[cellIndex].text;    
                            }
                        })
                        table[index] = tcells;
                    }
                })
            } catch (error) {
                console.error(error);
            }
            return table;
        }
    },
}
</script>